class StoreFamily {
  constructor (
    id = undefined,
    name,
    description,
    enabled,
    mobileDeviceCount = 0,
    trackerDeviceCount = 0,
    isDefault,
    activeDeviceColor = null,
    treatInactiveAsActive = false
  ) {
    this.id = id
    this.name = name
    this.description = description
    this.enabled = enabled
    this.mobileDeviceCount = mobileDeviceCount
    this.trackerDeviceCount = trackerDeviceCount
    this.isDefault = isDefault
    this.activeDeviceColor = activeDeviceColor ?? null
    this.treatInactiveAsActive = !!treatInactiveAsActive
  }

  toNormalizedRESTModel () {
    const model = {
      // id is read-only
      name: this.name,
      description: this.description,
      enabled: this.enabled,
      // Empty string clears override on update; omit would leave unchanged (additive).
      activeDeviceColor: this.activeDeviceColor || '',
      treatInactiveAsActive: !!this.treatInactiveAsActive
    }
    // Only send when explicitly set (super-admin toggle); omit otherwise so API leaves IsDefault unchanged.
    if (typeof this.isDefault === 'boolean') {
      model.isDefault = this.isDefault
    }
    return model
  }

  static FromNormalizedRESTModel ({
    id,
    name,
    description,
    enabled,
    mobileDeviceCount,
    trackerDeviceCount,
    isDefault,
    activeDeviceColor,
    treatInactiveAsActive
  }) {
    return new StoreFamily(
      id,
      name,
      description,
      enabled,
      mobileDeviceCount,
      trackerDeviceCount,
      isDefault,
      activeDeviceColor,
      treatInactiveAsActive
    )
  }

  toJSON () {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      enabled: this.enabled,
      mobileDeviceCount: this.mobileDeviceCount,
      trackerDeviceCount: this.trackerDeviceCount,
      isDefault: this.isDefault,
      activeDeviceColor: this.activeDeviceColor,
      treatInactiveAsActive: this.treatInactiveAsActive
    }
  }

  static FromJSON ({
    id,
    name,
    description,
    enabled,
    mobileDeviceCount,
    trackerDeviceCount,
    isDefault,
    activeDeviceColor,
    treatInactiveAsActive
  }) {
    return new StoreFamily(
      id,
      name,
      description,
      enabled,
      mobileDeviceCount,
      trackerDeviceCount,
      isDefault,
      activeDeviceColor,
      treatInactiveAsActive
    )
  }
}

export default StoreFamily
